export default __webpack_public_path__ + "static/media/bh9.39c4a04c.jpg";